import React from 'react';
import { Button } from '../ui';

interface Props {
  pagina: number;
  paginas: number;
  onPagina: (p: number) => void;
}

/** "Página N de M" con Anterior / Siguiente. No se muestra si hay una sola página. */
const Paginador: React.FC<Props> = ({ pagina, paginas, onPagina }) => {
  if (paginas <= 1) return null;
  return (
    <div className="mt-3 flex items-center justify-between gap-2 border-t border-slate-100 pt-3 text-xs text-slate-500">
      <span className="tabular-nums">
        Página {pagina} de {paginas}
      </span>
      <span className="flex gap-1">
        <Button
          type="button"
          variant="secondary"
          disabled={pagina <= 1}
          onClick={() => onPagina(pagina - 1)}
        >
          Anterior
        </Button>
        <Button
          type="button"
          variant="secondary"
          disabled={pagina >= paginas}
          onClick={() => onPagina(pagina + 1)}
        >
          Siguiente
        </Button>
      </span>
    </div>
  );
};

export default Paginador;
